import React, { useState, useEffect } from 'react'
import ReactSlider from 'react-slider'
import './slider.css'

export default function SliderCalculator(props) {
  const [currentValue, setCurrentValue] = useState(
    (props.value && props.selectFieldOptions.find((x) => x.value === props.value)) ||
      props.selectFieldOptions[0]
  )
  const [badgeText, setBadgeText] = useState('')
  const [tooltipText, setTooltipText] = useState('')

  useEffect(() => {
    setTooltipText(
      currentValue
        ? (props.tooltipFormat || '{label}')
            .replace('{label}', currentValue.text)
            .replace('{value}', currentValue.value)
        : ''
    )

    setBadgeText(
      currentValue
        ? (props.badgeFormat || '{label}')
            .replace('{label}', currentValue.text)
            .replace('{value}', currentValue.value)
        : ''
    )
  }, [currentValue])

  const itemCount = props.selectFieldOptions.length

  return (
    <div>
      <div className="flex justify-between text-sm text-grey-700 mb-2">
        <p>{props.selectFieldOptions[0].text}</p>
        <p>{props.selectFieldOptions[props.selectFieldOptions.length - 1].text}</p>
      </div>
      <div className="flex flex-nowrap items-start justify-between">
        {props.icon && (
          <div className="relative w-6 -mt-2">
            <img src={props.icon.url} alt="" className="w-5 select-none" />
          </div>
        )}
        <div className={`relative w-full`}>
          <ReactSlider
            className="w-full h-5"
            marks
            markClassName="w-1 h-1 bg-blue-300 rounded-full "
            step={1}
            min={0}
            max={itemCount - 1}
            onChange={(newValue) => {
              const selectValue = props.selectFieldOptions[newValue]
              setCurrentValue(selectValue)
              if (typeof props.onChange === 'function') {
                props.onChange(selectValue.value)
              }
            }}
            thumbClassName="thumb-hover variant relative outline-none w-4 h-4 border-2 border-blue-300 bg-green-100 text-white text-xs text-center cursor-pointer rounded-full  -mt-2"
            trackClassName="track-bg-small"
            renderThumb={(props) => (
              <div className="relative z-2" {...props}>
                <div className="w-full h-full p-1 hover-value">
                  <span className="value-label dark-blue text-center whitespace-nowrap absolute -bottom-10 left-1/2 -translate-x-1/2 bg-blue-300 py-1 px-3 min-w-50 rounded-lg text-xs text-white">
                    {tooltipText}
                  </span>
                </div>
              </div>
            )}
          />
        </div>
      </div>
      <h3
        className={`${
          props.technology
            ? 'float-right text-xs shrink-0 my-auto text-white ml-1 bg-black inline-block p-1 rounded'
            : 'text-3xl'
        } font-semibold`}
      >
        {badgeText}
      </h3>
    </div>
  )
}
